import * as React from "react";
import { observer } from "mobx-react";
import { PulseBetMarketComponentData } from "../../data/models";

// imported only for typings
// these are passed to the component from index.ts
import { BaseDict } from "./dict";
import { PulseBetMarketsData, BetPlacementModel, BetPlacementStatus } from "./data";

import * as SCMP from "../../components";
import * as CMP from "./components";

@observer
export class PulseBetMarkets extends React.Component<{
    dataProvider: PulseBetMarketsData
    dict: BaseDict
}, {
    dataProvider: PulseBetMarketsData
}> {
    dict: BaseDict
    countDownValues: string[]
    constructor(props) {
        super(props);

        // setup dictionary
        this.dict = this.props.dict;
        this.countDownValues = ["3", "2", "1", this.props.dict.GoLabel];
        // setup data provider
        this.state = {
            dataProvider: this.props.dataProvider
        }
    }

    // A check needed to show which component should be rendered
    renderPulseBetContainer(pulseBetMarket: PulseBetMarketComponentData) {
        return (
            <div className="rj-pulse-bet-market__collapsible-wrap" key={`${pulseBetMarket.pulseBetMetadata.name}`}>
                <SCMP.InstantCollapsible
                    trigger={
                        <SCMP.Heading label={pulseBetMarket.pulseBetMetadata.name} />
                    }
                    content={
                        <div className="rj-pulse-bet-market-main-container" >
                            {this.state.dataProvider.eventsBetPlacementResult.map(data =>
                                pulseBetMarket.pulseBetMetadata.marketId === data.eventId &&
                                this.renderMarket(data, pulseBetMarket))}
                        </div>
                    }
                    initiallyExpanded={true}
                />

            </div>
        )
    }

    // TODO Add proper tests https://jira.sbtech.com/browse/SB-130238
    /* istanbul ignore next */
    renderPulseContent(pulseBetMarket: PulseBetMarketComponentData, betPlacementData: BetPlacementModel) {
        return (
            <div className="rj-pulse-bet-markets" data-suspended={this.state.dataProvider.isDanger}>

                <SCMP.Winnings inputData={pulseBetMarket.winings} onStakeChangeFading={pulseBetMarket.onStakeChangeFading} />

                <CMP.TimePeriod periodFrames={pulseBetMarket.periodFrames.map(period => `${period} ${this.state.dataProvider.addSuffix(pulseBetMarket.pulseBetMetadata.marketId)}`)} />

                <div className="rj-pulse-bet-markets__pre-bet">
                    <SCMP.SlimProgressbar eventID={pulseBetMarket.pulseBetMetadata.marketId} />
                </div>

                <div className="rj-pulse-bet-markets__btns-holder">
                    <CMP.StakeHolder data={this.state.dataProvider.stakeInputDataView(pulseBetMarket.pulseBetMetadata.marketId)} />
                    <SCMP.PulseBetButton handler={pulseBetMarket.externalPlaceBetHandler} isDisabled={this.state.dataProvider.isDanger}>
                        {this.state.dataProvider.placeButtonText}
                    </SCMP.PulseBetButton>
                </div>
                <div className="rj-pulse-bet-markets__messages">
                    {betPlacementData.status === BetPlacementStatus.Error && <CMP.ErrorMessage error={betPlacementData.error} />}
                    {this.state.dataProvider.isUserLogged &&
                        this.state.dataProvider.userInfo.TaxProvider && !!this.state.dataProvider.userInfo.TaxProvider.TaxInfo.CountryTax &&
                        <CMP.GermanTaxesMessage text={this.props.dict.GermanTaxesMessage.format(this.state.dataProvider.userInfo.TaxProvider.TaxInfo.CountryTax)} />}
                </div>
            </div>
        )
    }

    renderAcceptedBetMessage(betPlacementData: BetPlacementModel) {
        return (
            <CMP.AcceptedBet data={betPlacementData.success} />
        )
    }

    renderMarket(betPlacementData: BetPlacementModel, pulseBetMarket: PulseBetMarketComponentData) {
        return (
            <React.Fragment key={`${pulseBetMarket.pulseBetMetadata.marketId}`}>
                {this.renderPulseBetMarketView(pulseBetMarket, betPlacementData)}
            </React.Fragment>
        )
    }

    renderPulseBetMarketView(pulseBetMarket: PulseBetMarketComponentData, betPlacementData: BetPlacementModel) {
        switch (betPlacementData.status) {
            case BetPlacementStatus.InProcess:
                return <CMP.PulseLoading />;

            case BetPlacementStatus.Success:
                return this.renderAcceptedBetMessage(betPlacementData);

            case BetPlacementStatus.Error:
            case BetPlacementStatus.NotStarted:
            default:
                return this.renderPulseContent(pulseBetMarket, betPlacementData);
        }
    }

    render() {
        return (
            <>
            {this.state.dataProvider.store.pulsebetsDataForComponents.map((data) => this.renderPulseBetContainer(data))}
            </ >
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./blocks/PulseBetMarkets/PulseBetMarkets.tsx